<template>
  <div class="check_box">
    <Header @search="onSearch" />
    <el-main class="mainCss">
      <el-row>
        <el-col class="cms-page-title" :span="24">{{ $t('身份验证') }}</el-col>
      </el-row>
      <el-row class="tips">
        <el-col>
          {{ $t('媒体注册审核结果更新可能存在延时。') }}
        </el-col>
        <el-col>
          {{ $t('请访问') }}
          <a :href="mediaLink" target="_blank" @click.prevent="mediaRegister">{{
            $t('媒体注册系统')
          }}</a>
          {{ $t('进行注册或查询审核状态。') }}
        </el-col>
      </el-row>
      <el-row class="no_re">
        <div>
          ×
        </div>
        {{ $t('验证不通过！') }}
      </el-row>
      <el-row>
        <el-button class="backBtn" @click="backHome">
          {{ $t('返回新闻中心') }}
        </el-button>
      </el-row>
    </el-main>
    <Footer />
  </div>
</template>
<script>
// import '@/assets/css/home.css'
import Header from '@/views/news/components/headerBanner'
import Footer from '@/views/news/components/footer'
export default {
  data() {
    return {
      mediaLink: process.env.VUE_APP_MEDIA
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    onSearch(input) {
      this.$router.push({
        name: 'pc_search',
        query: {
          search: input
        }
      })
    },
    backHome() {
      this.$router.push('/home')
    },
    mediaRegister() {
      window.location.href = 'https://media.ciftis.org'
      // this.$alert(this.$t('媒体记者注册已关闭'), {
      //   confirmButtonText: this.$t('确定'),
      //   callback: () => {}
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
.check_box {
  width: 100%;
  font-size: 14px;
}
.tips {
  background: #fdfcec;
  text-align: center;
  margin: 0 auto;
  border: 1px solid #fe8c01;
  color: #fe8c01;
  width: 620px;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 0;
  a {
    color: red !important;
    text-decoration: underline;
  }
}
.mainCss {
  height: 83vh;
  border-top: 1px solid #ddd;
  text-align: center;
  padding-top: 50px;
  background: #fff;
  color: #333333;
  .cms-page-title {
    padding: 20px 0;
    font-size: 24px;
    margin-bottom: 10px;
  }
  .no_re {
    font-size: 32px;
    margin-top: 20px;
    padding: 20px 0 5px;
    div {
      display: inline-block;
      width: 36px;
      height: 36px;
      line-height: 36px;
      color: #fff;
      font-size: 30px;
      border-radius: 100%;
      margin-bottom: -8px;
      margin-left: -10px;
      text-align: center;
      background: #ff4500;
    }
  }
  .backBtn {
    width: 189px;
    margin-top: 40px;
    background: linear-gradient(90deg, #ffb301 0%, #fe8c01 99%);
    font-size: 14px;
    color: #fff;
  }
  .wrong {
    background: #ff4500;
  }
  .right {
    background: #19c820;
  }
}
</style>
